<template>
<!-- 包裹线边框 -->
  <div id="wrap-line-border" class="menu-content-border-box">
    <div class="menu-use-content-inside" ref="wrapLineBorderBox">
      <ul class="menu-use-box">
        <li
          v-for="(item, index) in layoutStyleList"
          :key="index"
          @click="getNodeTypeAccout(item.nodeType,mapEditDarkMode?item.imgWhite:item.layoutIcon)"
        >
          <img v-if="mapEditDarkMode" :src="item.imgWhite" />
          <img v-else :src="item.layoutIcon" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapMutations,mapState } from "vuex";
import EncircleShapeType from '../../../viewmodel/datatype/EncircleShapeType';
export default {
  name: "ComplieChildMenuLayout",
  data() {
    return {
      layoutStyleList: [
        {
          layoutIcon: require("../../../assets/img/mapIcon/res/mipmap-right-menu/encircleLine/lightModeIcon/border_trapezoid.svg"),
          imgWhite: require("../../../assets/img/mapIcon/res/mipmap-right-menu/encircleLine/darkModeIcon/border_trapezoid.svg"),
          nodeType: EncircleShapeType.LAYOUT_TRAPEZOID,
        },
        {
          layoutIcon: require("../../../assets/img/mapIcon/res/mipmap-right-menu/encircleLine/lightModeIcon/border_rectangle1.svg"),
          imgWhite: require("../../../assets/img/mapIcon/res/mipmap-right-menu/encircleLine/darkModeIcon/border_rectangle1.svg"),
          nodeType: EncircleShapeType.LAYOUT_RECTANGLE_1,
        },
        {
          layoutIcon: require("../../../assets/img/mapIcon/res/mipmap-right-menu/encircleLine/lightModeIcon/border_rectangle2.svg"),
          imgWhite: require("../../../assets/img/mapIcon/res/mipmap-right-menu/encircleLine/darkModeIcon/border_rectangle2.svg"),
          nodeType: EncircleShapeType.LAYOUT_RECTANGLE_2,
        },
        {
          layoutIcon: require("../../../assets/img/mapIcon/res/mipmap-right-menu/encircleLine/lightModeIcon/border_rectangle3.svg"),
          imgWhite: require("../../../assets/img/mapIcon/res/mipmap-right-menu/encircleLine/darkModeIcon/border_rectangle3.svg"),
          nodeType: EncircleShapeType.LAYOUT_RECTANGLE_3,
        },
        {
          layoutIcon: require("../../../assets/img/mapIcon/res/mipmap-right-menu/encircleLine/lightModeIcon/border_rectangle4.svg"),
          imgWhite: require("../../../assets/img/mapIcon/res/mipmap-right-menu/encircleLine/darkModeIcon/border_rectangle4.svg"),
          nodeType: EncircleShapeType.LAYOUT_RECTANGLE_4,
        }

      ],
      layoutType: "",
      viewModel: null,
    };
  },
  computed: {
    ...mapState({
      mapEditDarkMode: (state) => state.mapEditIsDardarkMode.darkMode,//深色模式
    }),
  },
  created() {},
  mounted() {
    if (this.viewModel == null) {
      this.viewModel = this.$store.state.editMindmap;
    }
    this.setDardarkMode();
  },
  methods: {
    ...mapMutations(["setEncircleLineType","borderStyleLayout"]),
    getNodeTypeAccout(type,url) {
      this.setEncircleLineType(type)
      this.borderStyleLayout(url)

      //将点击的值传送到页面。
      // this.bus.$emit("isShowMindMenu", false);
    },
    setDardarkMode() {
      // 设置深色模式
      this.$nextTick(() => {
        let boxDom = this.$refs.wrapLineBorderBox;
        let dardarkMode = this.$store.state.mapEditIsDardarkMode;
        if (boxDom) {
          if (dardarkMode.darkMode) {
            boxDom.style.border = '1px solid rgba(255,255,255,.3)';
            boxDom.style.background = dardarkMode.bgColor;
          } else {
            boxDom.style.border = 0;
            boxDom.style.background = "#fff";
          }
        }
      });
    },
  },
  watch:{
    "$store.state.mapEditIsDardarkMode": {
      //导图编辑页面是否为深色模式
      handler(newVal, oldVal) {
        this.setDardarkMode();
      },
      deep: true,
    },
  }
};
</script>
<style scoped>
.menu-use-content-inside {
  width: 268px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 2px 2px 10px 6px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  position: relative;
  z-index: 9999;
}
.menu-use-content-inside ul {
  padding-left: 0;
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  flex-wrap: wrap;
}
.menu-use-content-inside ul li {
  width: 45px;
  height: 45px;
  list-style: none;
  margin: 3px 8px;
  padding: 3px 3px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu-use-content-inside ul li:hover {
  background: #e0e0e0;
}
.menu-use-content-inside ul li img {
  width: auto;
  height: auto;
}
.menu-theme-border {
  background: #e0e0e0;
}
</style>